import { render } from "./SendSms.vue?vue&type=template&id=231f4133&scoped=true"
import script from "./SendSms.vue?vue&type=script&lang=js"
export * from "./SendSms.vue?vue&type=script&lang=js"

import "./SendSms.vue?vue&type=style&index=0&id=231f4133&scoped=true&lang=css"
import "./SendSms.vue?vue&type=style&index=1&id=231f4133&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231f4133"]])

export default __exports__